import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, ToggleControl, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcHeaderPadding,
        hfcHeaderInnerWidth,
        hfcHeaderBGcolor,
        hfcHeaderLinksColor,
        hfcHeaderLinksHoverColor,
        hfcHeaderBtncolor,
        hfcHeaderBtnHovercolor,
        hfcHeaderBorderColor,
        hfcSubmenusBorderColor,
        hfcSubmenusBgHoverColor,
        hfcHeaderHasBorder,
        hfcHeaderIsTransparent,
        hfcHeaderIsSticky,
        hfcHeaderBoxShadow,
        hfcHeaderTitleBadge,
        hfcHeaderDescBox,
        hfcHeaderSubmenuWidth

    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: ('hfc-header-' + clientIdSliced) });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'core/site-logo',
        'core/navigation',
        'core/navigation-link',
        'core/buttons',
        'core/button'
    ];

    const TEMPLATE = [['core/group', {
        tagName: 'header'
    }, [
        ['core/columns', {
            verticalAlignment: 'center',
            className: 'hfc-cols-header-1'
        }, [
            ['core/column', {
                width: '25%',
                className: 'hfc-col-header-1'
            }, [
                ['core/site-logo', {
                    className: 'hfc-logo-header-1'
                }]
            ]],
            ['core/column', { width: '50%', className:'hfc-col-header-1'},[
                ['core/navigation', {
                    className: 'hfc-nav-header-1',
                    showSubmenuIcon: false,
                    icon: "menu"
                }, [
                    ['core/navigation-link', {
                        label: 'Home',
                        url: '#'
                    }],
                    ['core/navigation-link', {
                        label: 'Services',
                        url: '#'
                    }],
                    [
                        'core/navigation-submenu',
                        {
                            label: 'Portfolio',
                            url: '#',
                            className: "hfc-submenu-wrapper"
                        },
                        [
                            ['core/navigation-link', { label: 'Portfolio 1', url: '#' }],
                            ['core/navigation-link', { label: 'Portfolio 2', url: '#' }],
                            ['core/navigation-link', { label: 'Portfolio 3', url: '#', title: 'new' }]
                        ]
                    ],                                                             
                    ['core/navigation-link', {
                        label: 'Blog',
                        url: '#',
                        description: '📢 Lorem ipsum dolor sit amet consectetur adipiscing elit, inceptos commodo hendrerit auctor convallis. <strong>Purus integer</strong> tristique tellus mauris a scelerisque arcu molestie lectus aenean.'
                    }],
                    ['core/navigation-link', {
                        label: 'About Us',
                        url: '#'
                    }]
                ]]
            ]],
            ['core/column', {
                width: '25%',
                className: 'hfc-col-header-1 hfc-col-right-header-1'
            }, [
                ['core/buttons', {}, [
                    ['core/button', {
                        text: 'Get Started!',
                        url: '#',
                        rel: 'nofollow',
                        style: {
                            typography: {
                                fontSize: '18px'
                            },
                        }
                    }],
                ]]
            ]],
        ]]
    ]]];

    const hfcDynamicStyles = `/* Theme Compatibility - GeneratePress */
    .editor-styles-wrapper .wp-block-hfc-blocks-header-1 {
        max-width: 100% !important;
    }
    .editor-styles-wrapper .wp-block-hfc-blocks-header-1 .wp-block-group__inner-container{
        max-width: 1200px;
        margin: 0 auto!important;
    }
    .editor-styles-wrapper .wp-block-group__inner-container{
        padding: 0px;
    }
    .editor-styles-wrapper .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__responsive-container-content {
        justify-content: center;
    }
    .editor-styles-wrapper .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__responsive-container-content .wp-block-navigation__container.block-editor-block-list__layout {
        gap: 28px;
    }
    .editor-styles-wrapper .hfc-cols-header-1 .block-editor-block-list__block{
       padding: 0;
    }
    .editor-styles-wrapper .hfc-cols-header-1 .wp-block-navigation__submenu-container .wp-block-navigation-item__content::after,
    .editor-styles-wrapper .hfc-cols-header-1 .wp-block-navigation__submenu-container .wp-block-navigation-item__label::after{
       display: none!important;
    }
    /* Start Main Styles */
    #${id}.hfc-main-header-1,
    #${id}.hfc-main-header-1 header.wp-block-group{
       width: 100% !important;
       max-width: 100%!important;
    }
    #${id}.hfc-main-header-1 header.wp-block-group {
        padding: ${hfcHeaderPadding}px;
        background: ${hfcHeaderBGcolor};
        ${hfcHeaderHasBorder ? `border-bottom: 1px solid ` + hfcHeaderBorderColor : ``};
    }
    #${id}.hfc-main-header-1 header.wp-block-group .wp-block-columns {
        max-width: ${hfcHeaderInnerWidth};
        margin: auto!important;
    }
    #${id}.hfc-main-header-1 .wp-block-columns.hfc-cols-header-1 {
        display: flex;
        align-items: center !important;
    }
    #${id}.hfc-main-header-1 .hfc-col-header-1 ..hfc-logo-header-1 a{
       display: inline-flex;
       line-height: 1;
    }
    #${id}.hfc-main-header-1 .hfc-col-header-1,
    #${id}.hfc-main-header-1 .hfc-col-header-1 .hfc-logo-header-1{
       line-height: 1;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 {
        display: flex;
        align-items: center;
        justify-content: center;
        position: unset;
        margin: 0px;
    }
     #${id} .wp-block-navigation .wp-block-navigation-link a:focus .wp-block-navigation-item__label, 
     #${id} .wp-block-navigation .wp-block-navigation-link.current-menu-item .wp-block-navigation-item__label{
        border-bottom: none!important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .hfc-submenu-wrapper > .wp-block-navigation__submenu-container{
        margin-top: calc(${hfcHeaderPadding}px + 10px);
        align-items: normal;
        display: flex;
        flex-direction: column;
        height: 0;
        left: -1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        top: 100%;
        transition: opacity .1s linear;
        visibility: hidden;
        width: 0;
        z-index: 2;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .hfc-submenu-wrapper:hover > .wp-block-navigation__submenu-container{
        opacity: 1!important;
        overflow: visible!important;
        visibility: visible!important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container{
        border-top: 2px solid ${hfcSubmenusBorderColor};
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__container > .wp-block-navigation-submenu > a{
        position: relative;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__container > .wp-block-navigation-submenu > a::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 7px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation-submenu > a:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container .wp-block-navigation-item{
        margin-top: 0px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container .wp-block-navigation-item:hover{
        background-color: ${hfcSubmenusBgHoverColor};
    }
    #${id} .wp-block-column.hfc-col-right-header-1 .wp-block-buttons {
        justify-content: right;
    }
    #${id} .hfc-col-right-header-1 .wp-block-buttons .wp-block-button__link {
        background-color: ${hfcHeaderBtncolor};
        text-wrap: nowrap;
        border-radius: 5px;
        padding: 15px 30px;
        border: none;
        color: #fff;
        line-height: normal;
    }
    #${id} .hfc-col-right-header-1 .wp-block-buttons .wp-block-button__link:hover {
        background-color: ${hfcHeaderBtnHovercolor};
    }
    ${hfcHeaderSubmenuWidth ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content{
        position: relative;
        font-size: 18px;
        font-weight: 500;
        line-height: 30px;
        color: ${hfcHeaderLinksColor};
        text-decoration: none;
        box-sizing: border-box;
        z-index: 1;
        align-items: center;
        min-width: max-content;
        }`: ` #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content {
        position: relative;
        font-size: 18px;
        font-weight: 500;
        line-height: 30px;
        color: ${hfcHeaderLinksColor};
        text-decoration: none;
        box-sizing: border-box;
        z-index: 1;
        align-items: center;
    }`}
    #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:hover {
        color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .wp-block-navigation .hfc-nav-header-1 > .wp-block-navigation-item.has-mega-menu,
    #${id} .wp-block-navigation .hfc-nav-header-1 > .wp-block-navigation-item.has-child{
        padding-right: 15px;
    }
    #${id}.hfc-main-header-1 .wp-block-navigation-submenu .wp-block-navigation__submenu-icon svg{
        stroke: ${hfcHeaderLinksColor};
    }
    #${id}.hfc-main-header-1 .wp-block-navigation-submenu:hover .wp-block-navigation__submenu-icon svg{
        stroke: ${hfcHeaderLinksHoverColor};
    }
    ${hfcHeaderTitleBadge ? `.wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[title]:after {
        content: attr(title);
        position: relative;
        top: -14px;
        font-size: 10px;
        font-weight: bold;
        line-height: 10px;
        text-transform: uppercase;
        display: inline-block;
        padding: 3px 4px;
        background: #F44336;
        color: #fff;
    }
    #${id} ul.hfc-nav-header-1 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]:after {
        top: 4px;
        left: 10px;
        height: 100%;
    }` : ``}
    #${id}.hfc-main-header-1 .wp-block-navigation__container .block-list-appender{
        display: none;
    }
    ${hfcHeaderIsSticky ? `.hfc-main-header-1{
        position: sticky;
        top: 0;
    }` : `.hfc-main-header-1{
        position: relative;
    }`}
    ${hfcHeaderIsTransparent ? `.hfc-main-header-1 {
        position: absolute;
        top: 0;
    }
     #${id}.hfc-main-header-1 header.wp-block-group {
        background-color: transparent;
    }` : ``}
    ${hfcHeaderBoxShadow ? `.hfc-main-header-1 {
        box-shadow: 0 4px 7px rgb(199 199 199 / 10%);
    }` : ``}
       /* Mobile Menu Button */
     #${id} .hfc-nav-header-1 .wp-block-navigation__responsive-container-open{
        background-color: transparent!important;
    }
     #${id} .hfc-nav-header-1 .wp-block-navigation__responsive-container-open:hover svg {
        fill: ${hfcHeaderLinksHoverColor};
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close svg,
     #${id} .hfc-nav-header-1 .wp-block-navigation__responsive-container-open svg {
        fill: ${hfcHeaderLinksColor};
        width: 24px;
        height: 24px;
        transition: .3s;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close:hover svg {
        fill: ${hfcHeaderLinksHoverColor};
    }

    /* Responsive */
       @media (min-width: 599px) {
        #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content .wp-block-navigation-item__description{
            position: absolute;
            top: 100%;
            background: #fff;   
            min-width: 250px;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
            text-align: center;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.5;
            color: #000;
            z-index: 1;
            display: none;
            white-space:normal;
        }
         ${hfcHeaderDescBox ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:hover .wp-block-navigation-item__description {
            display: block;
    }`  : ``}
        #${id} .hfc-nav-header-1 .wp-block-navigation-item.has-mega-menu,
        #${id} .hfc-nav-header-1 .wp-block-navigation-item.has-child{
            padding-right: 15px;
            display: flex;
            cursor: pointer;
    }
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open:not(.always-shown),
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container:not(.is-menu-open) .wp-block-navigation__responsive-container-close{
            display: none;
    }
@media (max-width: 781px){
    #${id}.hfc-main-header-1 header.wp-block-group .wp-block-columns {
        flex-direction: column;
    }
    }
@media (max-width: 599px) {
      /* Reset */
    p,li{
      font-size: 16px!important;
    }
    #${id}.hfc-main-header-1 header.wp-block-group{
      padding: 20px 10px;
    }
    #${id}.hfc-main-header-1 .hfc-col-header-1 .hfc-logo-header-1 img{
      width: 120px;
    }
    #${id} .hfc-cols-header-1 .hfc-nav-header-1:has(.has-modal-open) .wp-block-navigation__responsive-container-open,
    #${id}.hfc-main-header-1 .hfc-col-right-header-1{
      display: none !important;
   }
    #${id} .hfc-cols-header-1 .wp-block-navigation__responsive-container.is-menu-open {
      animation: none;
   }
   #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open{
      position: absolute !important;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      transition: 0.4s;
    }
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close{
      position: absolute;
      top: -44px;
      right: 15px;
      z-index: 9999;
      background-color: transparent!important;
      transition: 0.4s;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open::before, 
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close::before{
        content: "Menu";
        font-size: 14px;
        position: absolute;
        font-weight: bold;
        color:${hfcHeaderLinksColor};
        right: 25px;
        top: 5px;
        white-space: nowrap;
        line-height: 1;
        text-transform: uppercase;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open:hover::before, 
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close:hover::before{
        color: ${hfcHeaderLinksHoverColor};
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open::after, 
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close::after{
        content: "";
        box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 8px 2px inset;
        height: 35px;
        width: 90px;
        position: absolute;
        right: -8px;
        top: -6px;
        border-radius: 10px;
        z-index: -1;
    }
     #${id}.hfc-main-header-1 .hfc-nav-header-1 .wp-block-navigation__responsive-dialog{
      margin-top: 0!important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-content{
      padding-top: 0!important;
    }
     #${id}.hfc-main-header-1 header.wp-block-group .wp-block-columns {
        flex-direction: row;
        flex-wrap: nowrap !important;
        gap: 0px;
    }
     #${id}.hfc-main-header-1 .hfc-nav-header-1 .wp-block-navigation-item .wp-block-navigation-item__content:hover{
       background-color: ${hfcSubmenusBgHoverColor}!important;
    }
    /* Mobile Menu Inner */
     #${id} .hfc-col-right-header-1 .wp-block-buttons a.wp-block-button__link {
        font-size: 12px !important;
        padding: 10px !important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation:not(.has-background) .wp-block-navigation__responsive-container.is-menu-open{
        background-color: transparent!important
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open{
        padding: 0px;
        height: 100vh;
        position: absolute;
        top: 100%;
        width: 100%;
        margin-top: 0px;
        overflow: visible;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation {
        display: block !important;
        width: 100%;
        background-color: #fff !important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container.is-menu-open a.wp-block-navigation-item__content {
        display: inline-block;
        font-size: 18px;
        width: 100%;
        padding: 10px;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-item:not(:last-child) {
        border-bottom: 1px solid #b7b7b7;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation-item.has-child .wp-block-navigation-submenu li:first-child {
        border-top: 1px solid #b7b7b7;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open ul.wp-block-navigation-submenu {
        padding: 0;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container .wp-block-navigation__submenu-container {
        width: 100% !important;
        border: none!important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container .hfc-submenu-wrapper{
        border-top: none!important;
     }
     #${id} .hfc-nav-header-1 ul.wp-block-navigation__submenu-container {
        display: none !important;
    }
     #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:before {
        background: none !important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation-item.has-child li a {
        padding: 10px 0 !important;
    }
     #${id} .wp-block-navigation.hfc-nav-header-1 li.wp-block-navigation-item.has-child{
        border-bottom: none;
    }
     #${id} .wp-block-navigation.hfc-nav-header-1 li.wp-block-navigation-item.has-child > a {
        position: relative;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        right: 18px;
    }
     #${id} .wp-block-navigation.hfc-nav-header-1 > li.wp-block-navigation-item.has-child > a::before,
     #${id} .hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 50px;
        width: 50px;
    }
     #${id}.wp-block-navigation.hfc-nav-header-1 li.wp-block-navigation-item.has-child > a::after {
        top: 20px;
        right: 20px;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child {
        position: relative!important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a,
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label{
        position: relative!important;
        padding-left: 20px!important;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before,
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        content: '';
        position: absolute;
        left: 10px;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(-45deg);
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content::after{
        content: '';
        position: absolute;
        right: 28px;
        height: 8px;
        width: 8px;
        top: 20px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before{
        top: 20px;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
        top: 6px;
    }
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:hover:before,
     #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::before{
        content: "";
        position: absolute;
        top: 0 !important;
        right: 0;
        border-left: 1px solid #b7b7b7;
        height: 50px;
        width: 50px;
    }
    #${id} .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::after{
        top: 20px!important;
        right: 20px;
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        right: 10px;
    }
}
    @media (max-width: 544px) {
    .wp-block-columns .wp-block-column:not(:last-child) {
        margin-bottom: 0px!important;
    }
    }
    /* Edit Page Compatibility */
    /* Astra Theme */
    .ast-separate-container .edit-post-visual-editor__content-area, .ast-separate-container .edit-post-visual-editor {
        padding: 0px !important;
    }
    .ast-separate-container .wp-block-navigation__submenu-container .wp-block-navigation-item__content{
        padding: 5px;
    }
    .editor-styles-wrapper {
        margin: 0px;
    }
    .editor-styles-wrapper .wp-block-navigation__container{
       justify-content: center;
     }
    .editor-styles-wrapper .hfc-main-header-1 a {
        text-decoration: none;
    }
    .editor-styles-wrapper .wp-block-post-content{
        padding: 0px;
    }
    .editor-styles-wrapper .hfc-col-right-header-1 .wp-block-button:not(.is-style-outline) .wp-block-button__link {
        background-color: ${hfcHeaderBtncolor};
        border-radius: 5px;
    }
    .editor-styles-wrapper .hfc-col-right-header-1 .wp-block-button:not(.is-style-outline) .wp-block-button__link:hover {
        background-color: ${hfcHeaderBtnHovercolor};
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Header Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <Heading className={'frhd__pb-heading'}>Header Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ hfcHeaderPadding: newValue })}
                    isDragEnabled
                    value={hfcHeaderPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Header Inner Width :')}
                    onChange={newValue => setAttributes({ hfcHeaderInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcHeaderInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Header Background Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Links Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinksColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Links Hover Color :</Heading>
                <ColorPalette
                    value={hfcHeaderLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Button Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBtncolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBtncolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Button Hover Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBtnHovercolor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBtnHovercolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Header Border Color :</Heading>
                <ColorPalette
                    value={hfcHeaderBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcHeaderBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Submenu Border Color :</Heading>
                <ColorPalette
                    value={hfcSubmenusBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcSubmenusBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Background Hover Color :</Heading>
                <ColorPalette
                    value={hfcSubmenusBgHoverColor}
                    onChange={(colorValue) => setAttributes({hfcSubmenusBgHoverColor: colorValue })}
                    clearable={false}
                />
                <ToggleControl
                    label={
                        hfcHeaderHasBorder
                            ? 'Header Border :'
                            : 'Header Border :'
                    }
                    checked={hfcHeaderHasBorder}
                    onChange={newValue => setAttributes({ hfcHeaderHasBorder: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderIsSticky
                            ? 'Header Sticky :'
                            : 'Header Sticky :'
                    }
                    checked={hfcHeaderIsSticky}
                    onChange={newValue => setAttributes({ hfcHeaderIsSticky: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderBoxShadow
                            ? 'Header Box Shadow :'
                            : 'Header Box Shadow :'
                    }
                    checked={hfcHeaderBoxShadow}
                    onChange={newValue => setAttributes({ hfcHeaderBoxShadow: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderTitleBadge
                            ? 'Show Title as Badge :'
                            : 'Show Title as Badge :'
                    }
                    checked={hfcHeaderTitleBadge}
                    onChange={newValue => setAttributes({ hfcHeaderTitleBadge: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderDescBox
                            ? 'Description on Hover :'
                            : 'Description on Hover :'
                    }
                    checked={hfcHeaderDescBox}
                    onChange={newValue => {
                        console.log('Toggle Value:', newValue);
                        setAttributes({ hfcHeaderDescBox: newValue });
                    }}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                <ToggleControl
                    label={
                        hfcHeaderDescBox
                            ? 'Header Submenu Width :'
                            : 'Header Submenu Width :'
                    }
                    checked={hfcHeaderSubmenuWidth}
                    onChange={newValue => {
                        console.log('Toggle Value:', newValue);
                        setAttributes({ hfcHeaderSubmenuWidth: newValue });
                    }}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-header-1'}>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        hfcHeaderPadding,
        hfcHeaderInnerWidth,
        hfcHeaderBGcolor,
        hfcHeaderLinksColor,
        hfcHeaderLinksHoverColor,
        hfcHeaderBtncolor,
        hfcHeaderBtnHovercolor,
        hfcHeaderBorderColor,
        hfcSubmenusBorderColor,
        hfcSubmenusBgHoverColor,
        hfcHeaderHasBorder,
        hfcHeaderIsTransparent,
        hfcHeaderIsSticky,
        hfcHeaderBoxShadow,
        hfcHeaderTitleBadge,
        hfcHeaderDescBox,
        hfcHeaderSubmenuWidth
    } = attributes;

    const hfcDynamicStyles = `#${id}.hfc-main-header-1,
    #${id}.hfc-main-header-1 header.wp-block-group {
        width: 100% !important;
        max-width: 100% !important;
    }
    #${id}.hfc-main-header-1 header.wp-block-group {
        padding: ${hfcHeaderPadding}px;
        background: ${hfcHeaderBGcolor};
        ${hfcHeaderHasBorder ? `border-bottom: 1px solid ` + hfcHeaderBorderColor : ``};
    }
    #${id}.hfc-main-header-1 header.wp-block-group .wp-block-columns {
        max-width: ${hfcHeaderInnerWidth};
        margin: auto!important;
    }
    #${id}.hfc-main-header-1 .wp-block-columns.hfc-cols-header-1 {
        display: flex;
        align-items: center !important;
    }
    #${id}.hfc-main-header-1 .hfc-col-header-1 ..hfc-logo-header-1 a{
       display: inline-flex;
       line-height: 1;
    }
    #${id}.hfc-main-header-1 .hfc-col-header-1,
    #${id}.hfc-main-header-1 .hfc-col-header-1 .hfc-logo-header-1{
       line-height: 1;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 28px;
        position: unset;
        margin: 0px;
    }
    #${id} .wp-block-navigation .wp-block-navigation-link a:focus .wp-block-navigation-item__label, 
    #${id} .wp-block-navigation .wp-block-navigation-link.current-menu-item .wp-block-navigation-item__label{
        border-bottom: none!important;
    }
    #${id} .wp-block-navigation .wp-block-navigation-submenu .wp-block-navigation-item:not(:last-child){
        margin-bottom: 0px!important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container .wp-block-navigation-item:hover{
        background-color: ${hfcSubmenusBgHoverColor};
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 > li.wp-block-navigation-item.has-child > a{
        position: relative;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 > li.wp-block-navigation-item.has-child > a::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 7px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${hfcHeaderLinksColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 > li.wp-block-navigation-item.has-child > a:hover::after{
        border-color: ${hfcHeaderLinksHoverColor};
    }
    #${id} .wp-block-column.hfc-col-right-header-1 .wp-block-buttons {
        justify-content: right;
    }
    #${id} .hfc-col-right-header-1 .wp-block-buttons a.wp-block-button__link {
        background-color: ${hfcHeaderBtncolor};
        border-radius: 5px;
        text-wrap: nowrap;
        color: #fff;
        padding: 15px 30px;
        line-height: normal;
    }
    #${id} .hfc-col-right-header-1 .wp-block-buttons a.wp-block-button__link:hover {
        background-color: ${hfcHeaderBtnHovercolor};
    }
     ${hfcHeaderSubmenuWidth ? ` #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content{
        position: relative;
        font-size: 18px;
        font-weight: 500;
        line-height: 30px;
        color: ${hfcHeaderLinksColor};
        text-decoration: none;
        box-sizing: border-box;
        z-index: 1;
        align-items: center;
        min-width: max-content;
        }`: ` #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content {
        position: relative;
        font-size: 18px;
        font-weight: 500;
        line-height: 30px;
        color: ${hfcHeaderLinksColor};
        text-decoration: none;
        box-sizing: border-box;
        z-index: 1;
        align-items: center;
    }`}
    #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:hover {
        color: ${hfcHeaderLinksHoverColor};
    }
    #${id}.hfc-main-header-1 .wp-block-navigation-submenu .wp-block-navigation__submenu-icon svg{
        stroke: ${hfcHeaderLinksColor};
    }
    #${id}.hfc-main-header-1 .wp-block-navigation-submenu:hover .wp-block-navigation__submenu-icon svg{
        stroke: ${hfcHeaderLinksHoverColor};
    }
    ${hfcHeaderTitleBadge ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content[title]::after {
        content: attr(title);
        position: relative;
        top: -14px;
        font-size: 10px;
        font-weight: bold;
        line-height: 10px;
        text-transform: uppercase;
        display: inline-block;
        padding: 3px 4px;
        background: #F44336;
        color: #fff;
    }
    #${id} ul.hfc-nav-header-1 ul.wp-block-navigation-submenu .wp-block-navigation-item__content[title]::after {
        top: 0;
        left: 10px;
        height: 100%;
    }` : ``}
     ${hfcHeaderIsSticky ? `.hfc-main-header-1{
        position: sticky;
        top: 0;
        z-index: 999;
    }` : `.hfc-main-header-1{
        position: relative;
        z-index: 999;
    }`}
    ${hfcHeaderIsTransparent ? `.hfc-main-header-1 {
        position: absolute;
        top: 0;
    }
    #${id}.hfc-main-header-1 header.wp-block-group {
        background-color: transparent;
    }` : ``}
    ${hfcHeaderBoxShadow ? `.hfc-main-header-1 {
        box-shadow: 0 4px 7px rgb(199 199 199 / 10%);
    }` : ``}
    /* Mobile Menu Button */
    #${id} .hfc-nav-header-1 .wp-block-navigation__responsive-container-open{
        background-color: transparent!important;
    }
    #${id} .hfc-nav-header-1 .wp-block-navigation__responsive-container-open:hover svg {
        fill: ${hfcHeaderLinksHoverColor};
    }
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close svg,
    #${id} .hfc-nav-header-1 .wp-block-navigation__responsive-container-open svg {
        fill: ${hfcHeaderLinksColor};
        width: 24px;
        height: 24px;
        transition: .3s;
    }
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close:hover svg {
        fill: ${hfcHeaderLinksHoverColor};
    }
      /* For site loading time header broken issue */
    #${id}.hfc-main-header-1 .wp-block-navigation__container .wp-block-navigation-item{
        list-style-type: none;
        white-space: nowrap;
   }
    #${id}.hfc-main-header-1 .wp-block-navigation__container{
        margin: 0px;
   }
    #${id}.hfc-main-header-1 .wp-block-navigation__container,
    #${id}.hfc-main-header-1 ul.wp-block-navigation-submenu{
        padding-left: 0px;
   }
    /* Responsive */
    @media (min-width: 599px) {
         #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content .wp-block-navigation-item__description{
            position: absolute;
            top: 100%;
            background: #fff;   
            min-width: 250px;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
            text-align: center;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.5;
            color: #000;
            z-index: 1;
            display: none;
            white-space: normal;
         }
         ${hfcHeaderDescBox ? `#${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:hover .wp-block-navigation-item__description {
            display: block;
    }`  : ``}
        #${id} .wp-block-navigation .hfc-nav-header-1 > .wp-block-navigation-item.has-mega-menu,
        #${id} .wp-block-navigation .hfc-nav-header-1 >.wp-block-navigation-item.has-child{
            padding-right: 15px;
            display: flex;
            cursor: pointer;
    }
    #${id} .wp-block-navigation .wp-block-navigation-item.has-child .hfc-submenu-wrapper{
        align-items: normal;
        display: flex;
        flex-direction: column;
        height: 0;
        left: -1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        top: 100%;
        transition: opacity .1s linear;
        visibility: hidden;
        width: 0;
        z-index: 2;
    }
    #${id} .wp-block-navigation .wp-block-navigation-item.has-child:hover .hfc-submenu-wrapper{
        opacity: 1!important;
        overflow: visible!important;
        visibility: visible!important;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container .wp-block-navigation-item{
        margin-top: 0px;
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 ul.hfc-submenu-wrapper{
        background-color: transparent;
        border: 1px solid transparent;
        padding-top: calc(${hfcHeaderPadding}px + 10px);
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container .hfc-submenu-wrapper-inner{
        background-color: #fff;
        border: 1px solid #00000026;
        border-top: 2px solid ${hfcSubmenusBorderColor};
    }
    #${id} .wp-block-navigation.hfc-nav-header-1 .wp-block-navigation__submenu-container{
        border-top: 2px solid ${hfcSubmenusBorderColor};
    }
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open:not(.always-shown),
    #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container:not(.is-menu-open) .wp-block-navigation__responsive-container-close{
            display: none;
    }
    }
    @media (max-width: 781px){
    #${id}.hfc-main-header-1 header.wp-block-group .wp-block-columns {
        flex-direction: column;
    }
    }
    @media (max-width: 599px) {
      /* Reset */
      p,li{
         font-size: 16px!important;
      }
      #${id}.hfc-main-header-1 header.wp-block-group{
           padding: 20px 10px;
      }
       #${id}.hfc-main-header-1 .hfc-col-header-1 .hfc-logo-header-1 img{
           width: 120px;
       }
       #${id} .hfc-cols-header-1 .hfc-nav-header-1:has(.has-modal-open) .wp-block-navigation__responsive-container-open,
       #${id}.hfc-main-header-1 .hfc-col-right-header-1{
            display: none !important;
        }
       #${id} .hfc-cols-header-1 .wp-block-navigation__responsive-container.is-menu-open {
            animation: none;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open{
            position: absolute !important;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            transition: 0.4s;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close{
            position: absolute;
            top: -44px;
            right: 15px;
            z-index: 9999;
            background-color: transparent!important;
            transition: 0.4s;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open::before, 
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close::before{
            content: "Menu";
            font-size: 14px;
            position: absolute;
            font-weight: bold;
            color:${hfcHeaderLinksColor};
            right: 25px;
            top: 5px;
            white-space: nowrap;
            line-height: 1;
            text-transform: uppercase;
        }
         #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open:hover::before, 
         #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close:hover::before{
            color: ${hfcHeaderLinksHoverColor};
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-open::after, 
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-close::after{
            content: "";
            box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 8px 2px inset;
            height: 35px;
            width: 90px;
            position: absolute;
            right: -8px;
            top: -6px;
            border-radius: 10px;
            z-index: -1;
        }
        #${id}.hfc-main-header-1 .hfc-nav-header-1 .wp-block-navigation__responsive-dialog{
            margin-top: 0!important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container-content{
            padding-top: 0!important;
        }
        #${id}.hfc-main-header-1 header.wp-block-group .wp-block-columns {
            flex-direction: row;
            flex-wrap: nowrap !important;
            gap: 0px;
        }
        #${id}.hfc-main-header-1 .hfc-nav-header-1 .wp-block-navigation-item .wp-block-navigation-item__content:hover{
            background-color: ${hfcSubmenusBgHoverColor}!important;
       }
        /* Mobile Menu Inner */
        #${id} .hfc-col-right-header-1 .wp-block-buttons a.wp-block-button__link{
            font-size: 12px!important;
            padding: 10px!important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation:not(.has-background) .wp-block-navigation__responsive-container.is-menu-open{
            background-color: transparent!important
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open {
            padding: 0px;
            height: 100vh;
            position: absolute;
            top: 100%;
            width: 100%;
            margin-top: 0px;
            overflow: visible;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation {
            display: block !important;
            width: 100%;
            background-color: #fff !important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container.is-menu-open a.wp-block-navigation-item__content {
            display: inline-block;
            font-size: 18px;
            width: 100%;
            padding: 10px;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-item:not(:last-child){
            border-bottom: 1px solid #b7b7b7;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation-item.has-child .wp-block-navigation-submenu li:first-child {
            border-top: 1px solid #b7b7b7;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open ul.wp-block-navigation-submenu {
            padding: 0;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container .wp-block-navigation__submenu-container{
            width: 100%!important;
            border: none!important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation__responsive-container .hfc-submenu-wrapper{
            border-top: none!important;
        }
        #${id} .hfc-nav-header-1 ul.wp-block-navigation__submenu-container{
            display: none!important;
        }
        #${id} .wp-block-navigation .wp-block-navigation-item__content.wp-block-navigation-item__content:before{
            background: none!important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation-item.has-child li a{
            padding: 10px 0!important;
        }
        #${id} .wp-block-navigation.hfc-nav-header-1 li.wp-block-navigation-item.has-child{
            border-bottom: none;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child  a{
            padding-left: 30px!important;
        }
        #${id} .wp-block-navigation.hfc-nav-header-1 li.wp-block-navigation-item.has-child > a{
            position: relative;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
            right: 18px;
        }
        #${id} .wp-block-navigation.hfc-nav-header-1 > li.wp-block-navigation-item.has-child > a::before,
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child::before{
            content: "";
            position: absolute;
            top: 0 !important;
            right: 0;
            border-left: 1px solid #b7b7b7;
            height: 50px;
            width: 50px;
        }
        #${id} .wp-block-navigation.hfc-nav-header-1 li.wp-block-navigation-item.has-child > a::after{
            top: 20px;
            right: 20px;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child {
            position: relative!important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a,
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label{
            position: relative!important;
            padding-left: 30px!important;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before,
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
            content: '';
            position: absolute;
            left: 10px;
            height: 8px;
            width: 8px;
            border-style: solid;
            border-color: ${hfcHeaderLinksColor};
            border-width: 0px 2px 2px 0px;
            transform: rotate(-45deg);
        }
         #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content::after{
            content: '';
            position: absolute;
            right: 20px;
            height: 8px;
            width: 8px;
            top: 20px;
            border-style: solid;
            border-color: ${hfcHeaderLinksColor};
            border-width: 0px 2px 2px 0px;
            transform: rotate(45deg);
         }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:before{
             top: 20px;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__responsive-container.is-menu-open .wp-block-navigation-submenu .wp-block-navigation-item__label:before{
             top: 6px;
        }
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > a:hover:before,
        #${id}.hfc-main-header-1 .wp-block-navigation .wp-block-navigation__submenu-container .wp-block-navigation-submenu.has-child > .wp-block-navigation-item__content:hover::after{
             border-color: ${hfcHeaderLinksHoverColor};
        }
        #${id} .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::before{
            content: "";
            position: absolute;
            top: 0 !important;
            right: 0;
            border-left: 1px solid #b7b7b7;
            height: 50px;
            width: 50px;
        }
        #${id} .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::after{
            top: 20px!important;
            right: 20px;
        }
        .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
           right: 10px;
        }
        }
    @media (max-width: 544px) {
        .wp-block-columns .wp-block-column:not(:last-child) {
            margin-bottom: 0px!important;
        }
    }`;

    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-header-1'}>
                <InnerBlocks.Content />
            </div>
        </>
    )
}